import Vue from 'vue'
import VueRouter from 'vue-router'
import Habits from '../views/Habits.vue'
import { auth } from '../firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Carpe Diem'
    }
  },
  {
    path: '/habits',
    name: 'Habits',
    component: Habits,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/create',
    name: 'CreateHabit',
    component: () => import('../views/CreateHabit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/edit',
    name: 'EditHabit',
    component: () => import('../views/EditHabit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tracker',
    name: 'tracker',
    props: true,
    component: () => import('../views/Tracker.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/habit',
    name: 'habit',
    props: true,
    component: () => import('../views/Habit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/prices',
    name: 'Prices',
    component: () => import('../views/Prices.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  if (requiresAuth && !auth.currentUser) {
    next('/')
  } else {
    next()
  }
})

export default router
